import { render, staticRenderFns } from "./priceBulkModifierEditor.vue?vue&type=template&id=12e1a58b&"
import script from "./priceBulkModifierEditor.vue?vue&type=script&lang=js&"
export * from "./priceBulkModifierEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports